import { render } from "./BasketSection.vue?vue&type=template&id=77687138&scoped=true"
import script from "./BasketSection.vue?vue&type=script&lang=js"
export * from "./BasketSection.vue?vue&type=script&lang=js"

import "./BasketSection.vue?vue&type=style&index=0&id=77687138&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77687138"]])

export default __exports__